export default __webpack_public_path__ + "static/media/EOTpic2.1c932a3f.jpg";